module.exports = __webpack_public_path__ + "img/guide-09.f021dea2.jpg";